import React, { createContext, useContext } from 'react';
const EnvironmentContext = createContext(undefined);
export const EnvironmentProvider = ({ environment, children, }) => {
    return (React.createElement(EnvironmentContext.Provider, { value: { environment } }, children));
};
export const useEnvironment = () => {
    const context = useContext(EnvironmentContext);
    if (!context) {
        throw new Error('useEnvironment must be used within an EnvironmentProvider');
    }
    return context;
};
//# sourceMappingURL=index.js.map